import { SelectionFieldItem } from './types-fields';

export const fieldsMap = {

  canMoveUp: (fields: SelectionFieldItem[], item: SelectionFieldItem) => {
    return fields.indexOf(item) > 0;
  },

  moveFieldUp: (fields: SelectionFieldItem[], item: SelectionFieldItem): SelectionFieldItem[] => {

    if (fieldsMap.canMoveUp(fields, item)) {
      const indexOfItem = fields.indexOf(item);

      return fieldsMap.moveField(fields, indexOfItem, indexOfItem - 1);
    } else {
      return fields;
    }
  },

  canMoveDown: (fields: SelectionFieldItem[], item: SelectionFieldItem) => {
    return fields.indexOf(item) < fields.length - 1;
  },

  moveFieldDown: (fields: SelectionFieldItem[], item: SelectionFieldItem): SelectionFieldItem[] => {

    if (fieldsMap.canMoveDown(fields, item)) {
      const indexOfItem = fields.indexOf(item);

      return fieldsMap.moveField(fields, indexOfItem, indexOfItem + 1);
    } else {
      return fields;
    }
  },

  showMissingValues: (fields: SelectionFieldItem[], item: SelectionFieldItem): SelectionFieldItem[] => {
    const modifiedLGroupByFields = [...fields];

    const updatedItem: SelectionFieldItem = {
      ...item,
      value: {
        ...item.value,
        fillEmpty: !item.value.fillEmpty
      }
    };
    const indexOfItem = modifiedLGroupByFields.indexOf(item);
    return [
      ...fields.slice(0, indexOfItem),
      updatedItem,
      ...fields.slice(indexOfItem + 1)
    ];
  },

  moveField: (fields: SelectionFieldItem[], sourceId: number, newIndex: number) => {
    const sourceField = fields[sourceId];
    const sourceItem: SelectionFieldItem = {
      ...sourceField,
      value: {
        ...sourceField?.value,
        rollingAverage: undefined
      }
    };
    const nextField = fields[newIndex];
    const nextItem: SelectionFieldItem = {
      ...nextField,
      value: {
        ...nextField.value,
        rollingAverage: undefined
      }
    };

    const modifiedFields = fields.filter(f => f !== sourceField).map(f => f !== nextField ? f : nextItem);

    return [
      ...modifiedFields.slice(0, newIndex),
      sourceItem,
      ...modifiedFields.slice(newIndex)
    ];
  }
};
